updateFragment